import React  from 'react';
import ResetPasswordComp from '../components/Login/resetPasswordComp';
function ResetPassword() {
  return (
    <>
    <ResetPasswordComp />
    </>
  );
}

export default ResetPassword;
